<script>
// import store from '@state/store'
import Layout from '@layouts/guest.vue'
import { authMethods, authComputed } from '@state/helpers'
import organizationSocialForm from '@/src/guest/components/organization-social-form.vue'

export default {
  page: {
    meta: [{ name: 'description', content: `Organization Social Setup` }],
  },
  components: { Layout, organizationSocialForm },
  data() {
    return {
      username: '',
      password: '',
      authError: '',
      submitError: '',
      token: null,
    }
  },
  computed: {
    ...authComputed,
    currentRouteName() {
      return this.$router.currentRoute.path
    },
  },
  mounted() {
    // Get token from route params
    this.token = this.$route.params.token
    if (!this.token) {
      this.submitError = 'Invalid setup link'
    }
  },
  methods: {
    ...authMethods,
    postSubmitSocial(params) {
      this.submitError = ''
      return this.organizationSetupSocial({
        token: this.token,
        hasX: params.hasX,
        xLink: params.xLink,
        hasFacebook: params.hasFacebook,
        facebookLink: params.facebookLink,
        hasInstagram: params.hasInstagram,
        instagramLink: params.instagramLink,
        hasLinkedIn: params.hasLinkedIn,
        linkedinLink: params.linkedinLink,
        hasCustom: params.hasCustom,
        customSocials: params.customSocials,
        email: params.email,
        phone: params.phone,
        uploadFile: params.uploadFile,
        uploadFileName: params.uploadFileName,
      }).then((response) => {
        // Check for error responses (422 validation errors or other errors)
        if (response.error || response.errors || response.success === false) {
          this.submitError =
            response.message ||
            response.error ||
            'An error occurred. Please try again.'
        } else {
          // Move to next step only if successful
          this.$router.push({
            name: 'organization-setup-admins',
            params: { token: this.token },
          })
        }
      })
    },
    clearSubmitErrors() {
      this.submitError = ''
    },
  },
}
</script>

<template>
  <Layout style="height: fit-content" class="mt-20 mb-20">
    <div>
      <h1 class="home-headline1">Let's start sharing kyndfulness</h1>
      <h2 class="home-headline2"
        >Finish Setting Up Your Organization's Profile</h2
      >
      <organizationSocialForm
        :submit-error="submitError"
        @post-submit-social="postSubmitSocial"
        @clear-submit-errors="clearSubmitErrors"
      >
      </organizationSocialForm>
    </div>
  </Layout>
</template>
